import { render, staticRenderFns } from "./AppMainView.vue?vue&type=template&id=53026568&"
import script from "./AppMainView.vue?vue&type=script&lang=js&"
export * from "./AppMainView.vue?vue&type=script&lang=js&"
import style0 from "./AppMainView.vue?vue&type=style&index=0&id=53026568&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports